// project imports
import axios from "utils/axios"
import * as APITypes from "constants/API"
import SolutionStore from "modules/solution/store/SolutionStore"
import { toJS } from "mobx"
import AuthStore from "modules/login/store/AuthStore"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants"

class Utils {
  fetchDocument = async (solutionList, language) => {
    SolutionStore.showPdfGeneratingMsg(true)
    const response = await axios.post(APITypes.FETCH_MULTIPLE_DMS_DOCUMENT,
      {
        "solution_id": solutionList,
        "user_journey_id": Number(getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)),
        "language": language ? language : null
      }
    )
   
    return response.data
  }

  sendSolutionList = async () => {
    const dmsData = toJS(SolutionStore.dmsDocumentData)

    const requestObj = { 
      "solution_list": null,
      "default_email": SolutionStore.defaultEmails,
      "optional_email": SolutionStore.optinalEmail?.email_id ? SolutionStore.optinalEmail?.email_id : "",
      "share_optional_email": SolutionStore.optinalEmail?.is_selected === true ? true : false
     }
    const requestBodyArray = dmsData.map(singleData => singleData.solution_id)
    requestObj.solution_list = requestBodyArray
    console.log('dmsData', requestObj);

    const response = await axios.post(APITypes.SEND_PDF, requestObj)
    return response
  }
}

export default new Utils()
